import { render, staticRenderFns } from "./OctSalonCustomerList.vue?vue&type=template&id=33a8d857&scoped=true&"
import script from "./OctSalonCustomerList.vue?vue&type=script&lang=js&"
export * from "./OctSalonCustomerList.vue?vue&type=script&lang=js&"
import style0 from "./OctSalonCustomerList.vue?vue&type=style&index=0&id=33a8d857&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a8d857",
  null
  
)

export default component.exports